var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series,"width":"100%","height":"500"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }